import { render, staticRenderFns } from "./DetailDataPeserta.vue?vue&type=template&id=bb9b55a4&scoped=true&"
import script from "./DetailDataPeserta.vue?vue&type=script&lang=js&"
export * from "./DetailDataPeserta.vue?vue&type=script&lang=js&"
import style0 from "./DetailDataPeserta.vue?vue&type=style&index=0&id=bb9b55a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9b55a4",
  null
  
)

export default component.exports